import { PropsWithChildren } from 'react';
import { css } from '@emotion/react';
import { motion } from 'motion/react';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

export const TooltipContainer = ({ children, className }: PropsWithChildren<{ className?: string }>) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.5 }}
      transition={{ type: 'spring', stiffness: 400, damping: 30, mass: 0.9 }}
      css={containerStyle}
      className={className}
    >
      {typeof children === 'string' ? (
        <Text size='medium' weight='semibold' color='default'>
          {children}
        </Text>
      ) : (
        children
      )}
    </motion.div>
  );
};

const containerStyle = css({
  pointerEvents: 'none',
  userSelect: 'none',
  borderRadius: theme.borderRadius.medium,
  background: theme.colors.white,
  boxShadow: theme.shadows.floating,
  padding: theme.spacing(1),
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  width: 'fit-content',
  maxWidth: 285,
  display: 'grid',
  gap: theme.spacing(0.25),
});
